// === STYLING CONSTANTS ===
export const STANDARD_BADGE_HEIGHT = 48;

// === GRADIENT COLORS ===
export const GRADIENT_SELECTED = "bg-gradient-to-r from-[var(--gradient-selected-start)] to-[var(--gradient-selected-end)]";

export const GRADIENT_NAV_ACTIVE = "bg-gradient-to-r from-[var(--gradient-nav-active-start)] to-[var(--gradient-nav-active-end)]";

// Category Definitions
export const categories = [
  { displayName: "Food", categories: ["Food"] },
  { displayName: "Drinks", categories: ["Drinks"] },
  { displayName: "Nightlife", categories: ["Nightlife"] },
  { displayName: "Arts", categories: ["Arts"] },
  { displayName: "Culture", categories: ["Culture"] },
  { displayName: "History", categories: ["History"] },
  { displayName: "Mobility", categories: ["Mobility"] },
  { displayName: "Technology", categories: ["Technology"] },
  { displayName: "Last Added", categories: ["Last Added"] },
  { displayName: "OSM Projects", categories: ["OSM Projects"] },
  { displayName: "Sports", categories: ["Sports"] },
  { displayName: "Outdoor", categories: ["Outdoor"] },
  { displayName: "Family", categories: ["Family"] },
  { displayName: "Health", categories: ["Health"] },
  { displayName: "Sustainability", categories: ["Sustainability"] },
  { displayName: "Support", categories: ["Support"] },
  { displayName: "Accessibility", categories: ["Accessibility"] },
  { displayName: "Nature", categories: ["Nature"] },
];

// Continent List
export const continents = [
  "World",
  "Africa",
  "Antarctica",
  "Asia",
  "Europe",
  "North America",
  "Oceania",
  "South America",
];